// The community details page's tab title (#751) — **break** (#724 Q2): the
// source set none, so the title stayed whatever the previous page left.
//
// "{name} - {fullId}" once the details read has answered a community — the
// read's full id, never the URL's — and "Community Details" otherwise: while
// it loads and on the 404 and error states (owner D4). The route's `head` and
// the page both read it, so a head the router re-projects on the spec table's
// `?sort=` / `?filters=` writes says what the page set.

/** The tab's title before the community loads and on the error states. */
export const COMMUNITY_PAGE_TITLE_FALLBACK = "Community Details";

export function communityPageTitle(
  community: { name: string; externalFullId: string } | null | undefined,
): string {
  return community
    ? `${community.name} - ${community.externalFullId}`
    : COMMUNITY_PAGE_TITLE_FALLBACK;
}
